import script from "./authorize-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./authorize-info.vue?vue&type=script&lang=ts&setup=true"

import "./authorize-info.vue?vue&type=style&index=0&id=81d61790&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d61790"]])

export default __exports__